import React from 'react'
import { Search, FileText, Eye, CheckCircle2 } from 'lucide-react'
import { getDocumentTypeLabel } from '../../constants/documentTypes'
import type { DocumentListProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'

export const DocumentList: React.FC<DocumentListProps> = ({
  documents,
  selectedDocId,
  onDocumentSelect,
  searchQuery,
  onSearchChange,
}) => {
  return (
    <>
      {/* Search */}
      <div className={styles.searchBox}>
        <Search size={14} />
        <input
          type="text"
          placeholder="Search documents..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {documents.length > 0 && <span className={styles.docCount}>{documents.length}</span>}
      </div>

      {/* Document List */}
      <div className={styles.documentList}>
        {documents.length > 0 ? (
          documents.map(doc => {
            const isSelected = selectedDocId === doc.id
            const hasClassification = !!doc.document_type
            const typeLabel = doc.document_type ? getDocumentTypeLabel(doc.document_type) : null

            return (
              <button
                key={doc.id}
                className={`${styles.documentItem} ${isSelected ? styles.documentItemActive : ''}`}
                onClick={() => {
                  // Skip if already viewing this document
                  if (isSelected) return
                  // Navigate to document URL (will trigger load via useEffect)
                  if (doc.id && (doc.downloadUrl || doc.storagePath)) {
                    onDocumentSelect(doc.id)
                  }
                }}
                disabled={!doc.downloadUrl && !doc.storagePath}
                type="button"
              >
                <FileText size={14} className={styles.documentItemIcon} />
                <div className={styles.documentItemInfo} title={doc.filename}>
                  <span className={styles.documentItemName}>{doc.filename}</span>
                  {hasClassification && (
                    <span className={styles.documentItemType}>{typeLabel}</span>
                  )}
                </div>
                {hasClassification ? (
                  <CheckCircle2 size={12} className={styles.documentItemCheck} />
                ) : (
                  <Eye size={12} className={styles.documentItemView} />
                )}
              </button>
            )
          })
        ) : (
          <div className={styles.emptyDocList}>
            <span>No documents yet</span>
          </div>
        )}
      </div>
    </>
  )
}

